import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { useTranslation } from 'react-i18next';
import { Label, Selector, Switcher, Notice } from 'shared/components';
import { formatPolicies, hasPermission } from 'shared/helpers';
import './styles.scss';

const ProductInformation = ({
  handleProductSelect,
  products,
  productPolicies,
  selectedProduct,
  selectedPolicy,
  handlePolicySelect,
  useCustomValues,
  setUseCustomValues,
}) => {
  const { t } = useTranslation();
  const canEditLicense = hasPermission('edit_license');
  const selectedProductActive = get(selectedProduct, 'data.active');
  const selectedProductArchived = get(selectedProduct, 'data.is_archived');
  const isDisabled = selectedProductActive === false;
  const isArchived = selectedProductArchived === true;
  return (
    <section className="ProductInformation">
      <div className="section-header first">{t('Product information')}</div>
      <div className="section-row">
        <Label inputId="product-input" text={t('Product name')} />
        <div className="product-selector-with-status">
          <Selector
            options={products}
            handleChange={handleProductSelect}
            value={get(selectedProduct, 'value')}
            inputId="product-input"
          />
          {(isDisabled || isArchived) && (
            <div className="product-status-tags">
              {isDisabled && (
                <div className="ProductStatusTag ProductStatusTag-disabled">
                  {t('Disabled')}
                </div>
              )}
              {isArchived && (
                <div className="ProductStatusTag ProductStatusTag-archived">
                  {t('Archived')}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="section-row">
        <Label inputId="product-policy" text={t('License policy')} />
        <Selector
          options={formatPolicies(productPolicies)}
          handleChange={handlePolicySelect}
          value={selectedPolicy}
          inputId="product-policy"
          disabled={useCustomValues}
        />
      </div>
      {canEditLicense && (
        <>
          <div className="section-row switcher-row">
            <Switcher
              checked={useCustomValues}
              handleChange={() => setUseCustomValues(!useCustomValues)}
              size="sm"
            />
            <Label
              inputId="custom-values"
              text={t('Use custom license values')}
            />
          </div>
          <Notice theme="info" size="sm">
            {t('Custom values allow you to edit license policy values.')}
          </Notice>
        </>
      )}
    </section>
  );
};

ProductInformation.propTypes = {
  handleProductSelect: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
  productPolicies: PropTypes.array.isRequired,
  selectedProduct: PropTypes.object.isRequired,
  selectedPolicy: PropTypes.string,
  handlePolicySelect: PropTypes.func.isRequired,
  useCustomValues: PropTypes.bool.isRequired,
  setUseCustomValues: PropTypes.func.isRequired,
};

ProductInformation.defaultProps = {
  selectedPolicy: '',
};

export default ProductInformation;
